import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetConnectionSequenceStepLogsResponse = App.Http.Responses.ConnectionSequenceStepLog.GetConnectionSequenceStepLogsResponse;
import GetConnectionSequenceStepLogResponse = App.Http.Responses.ConnectionSequenceStepLog.GetConnectionSequenceStepLogResponse;
import BaseExportRequest = App.Http.Requests.BaseExportRequest;
import ExportResponse = App.Http.Responses.ExportResponse;

class ConnectionSequenceStepLogApi extends TenantBaseApi {
    async index(request: { filter?: App.Http.Requests.FilterRequest }): Promise<GetConnectionSequenceStepLogsResponse> {
        return await this.get<GetConnectionSequenceStepLogsResponse, unknown>("/connection-sequence-step-logs", {
            params: request,
        });
    }

    async show(
        logId: string,
        request: {
            filter?: App.Http.Requests.FilterRequest;
        }
    ): Promise<GetConnectionSequenceStepLogResponse> {
        return await this.get<GetConnectionSequenceStepLogResponse, unknown>(
            `/connection-sequence-step-logs/${logId}`,
            {
                params: request,
            }
        );
    }

    async export(request?: BaseExportRequest): Promise<ExportResponse> {
        return await this.post<ExportResponse, BaseExportRequest>(`/connection-sequence-step-logs/export`, request);
    }
}

export const connectionSequenceStepLogApi = new ConnectionSequenceStepLogApi();
